import moment from 'moment';
import settings from '../../config/settings';

export default function (phase) { //eslint-disable-line
  const now = moment();
  const { phases } = settings;
  const { phase1Date, phase2Date } = phases;
  let currentPhase = null;

  if (now.isBefore(phase1Date)) {
    currentPhase = 'phase-0';
  } else if (now.isSameOrAfter(phase1Date) && now.isSameOrBefore(phase2Date)) {
    currentPhase = 'phase-1';
  } else if (now.isSameOrAfter(phase2Date)) {
    currentPhase = 'phase-2';
  }

  if (phase) return phase === currentPhase;
  return currentPhase;
}



// WEBPACK FOOTER //
// ./src/js/utils/phase.js